import React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  ${({ accessoryView }) => `
    padding: 30px 30px ${accessoryView ? '90px' : '76px'};

    @media ${minBp('tablet')} {
      padding: 46px 40px 100px 40px;
    }

    @media ${minBp('tabletLarge')} {
      padding: 65px 40px 100px 40px;
    }

    @media ${minBp('desktop')} {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 65px 160px 0 40px;
    }
  `}
`;

export const Title = styled.h3`
  ${({ hasSubtitle, previewedPack }) => `
    margin: 0 0 ${hasSubtitle ? 0 : '24px'} ${previewedPack ? '20px' : 0};
    text-transform: uppercase;
    text-align: center;
    font-size: 14px;
    line-height: 1.25;

    @media ${minBp('tabletLarge')} {
      font-size: 25px;
      text-align: left;
      margin: 0 0 24px ${previewedPack ? '20px' : 0};
    }
    
    @media ${minBp('desktop')} {
      margin: 0 0 10px ${previewedPack ? '20px' : 0};
    }
  `}
`;

export const TitleWrap = styled.button`
  ${({ isWindows }) => `
  position: relative;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  svg {
    display: block;
    position: absolute;
    top: ${isWindows ? '3px' : 0};
    height: 13px;
    width: 14px;

    @media ${minBp('tabletLarge')} {
      left: -10px;
      height: 25px;
      width: 25px;
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      left: -5px;
      top: 2px;
    }
  }
`};
`;

export const Subtitle = styled.div`
  text-transform: uppercase;
  text-align: center;
  font-size: 14px;
  line-height: 1.25;
  margin: 0 0 12px;
  color: #000000;

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const Description = styled.p`
  ${({ accessoryView }) => `
    display: none;

    @media ${minBp('tabletLarge')} {
      display: block;
      margin: 0 0 ${accessoryView ? 0 : '25px'};
      color: #000;
      font-size: 15px;
      line-height: 1.4;
      margin-bottom: 18px;
    }
  `}
`;

export const Summary = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  @media ${minBp('tabletLarge')} {
    margin-bottom: 10px;
  }
`;

export const Total = styled.div`
  flex: 1;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

export const TotalLabel = styled.span`
  display: inline-block;
  margin-right: 6px;
`;

export const TotalAmount = styled.span`
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-weight: 500;
  color: #000;
`;

export const RemoveButton = styled.button`
  ${({ theme, active }) => `
    appearance: none;
    display: inline-flex;
    border-radius: 4px;
    background-color: #2a2a2a;
    color: white;
    border: 0;
    font-family: ${theme.fonts.dinRegular};
    font-size: 12px;
    padding: 2px 8px 0;
    line-height: 1;
    height: 24px;
    align-items: center;
    justify-content: center;
    margin: 0;
    cursor: pointer;

    &:focus {
      background-color: ${lighten(0.15, '#2a2a2a')};
    }

    svg {
      height: 12px;
      width: 12px;
      margin-right: 3px;
      vertical-align: middle;
      position: relative;
      bottom: 1px;

      path {
        fill: white;
      }
    }
  `}
`;

export const InfoCircleWrap = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    position: relative;
    top: 2px;
  }

  svg {
    height: 16px;
    width: 16px;

    @media ${minBp('tabletLarge')} {
      height: 24px;
      width: 22px;
    }

    path {
      fill: #000;
    }
  }
`;
